import { Link, useLocalSearchParams } from "expo-router";
import { Pressable, StyleSheet, View } from "react-native";

import { Text } from "@/src/components/ui/BrandText";
import { action, radius, spacing, surface, text } from "@/src/theme/tokens";

export default function ControlAccessDeniedScreen() {
  const { reason } = useLocalSearchParams<{ reason?: string }>();
  const disabled = reason === "disabled";
  return <View style={styles.page}><Text style={styles.eyebrow}>NEQRAW CONTROL CENTER</Text><Text style={styles.title}>{disabled ? "Accès désactivé" : "Accès refusé"}</Text><Text style={styles.body}>{disabled ? "Ton membership existe, mais il a été désactivé par un administrateur." : "Ce compte Firebase ne dispose pas d’un membership Control Center actif."}</Text><Link href="/" asChild><Pressable accessibilityRole="link" style={styles.button}><Text style={styles.buttonText}>Retour à Neqraw</Text></Pressable></Link></View>;
}

const styles = StyleSheet.create({
  page: { alignItems: "center", backgroundColor: surface.secondary, flex: 1, gap: spacing.lg, justifyContent: "center", padding: spacing.xl },
  eyebrow: { color: text.brand, fontSize: 12, fontWeight: "800", letterSpacing: 2 },
  title: { color: text.primary, fontSize: 30, fontWeight: "800", textAlign: "center" },
  body: { color: text.secondary, lineHeight: 24, maxWidth: 520, textAlign: "center" },
  button: { backgroundColor: action.primary, borderRadius: radius.md, paddingHorizontal: spacing.xl, paddingVertical: spacing.md },
  buttonText: { color: text.inverse, fontWeight: "700" },
});
